module.exports = __webpack_public_path__ + "static/product-page-mobile-c2475714eba1ce96fd6eda31bc1133fb.jpg";